<template>
  <v-dialog :value="value" @input="$emit('input')" transition="fade-transition" max-width="700px">
    <v-card v-if="activePairingData" style="min-width:400px">
      <v-card-title class="headline">Confirm Payout</v-card-title>
      <v-card-text>
        <a
          class="title"
          :href="'https://www.instagram.com/' + activePairingData.instagramHandle"
          target="_blank"
        >@{{activePairingData.instagramHandle}}</a>
        <v-row>
          <v-col cols="12" md="12" sm="12" lg="12">
            <v-text-field
              label="Amount"
              v-model.number="activePairingData.payout"
              type="number"
              hide-details
              prefix="S$"
              @input="$v.activePairingData.payout.$touch()"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-textarea
              outlined
              name="remarks"
              label="Remarks"
              hide-details
              v-model="activePairingData.remarks"
              value
              @input="$v.activePairingData.remarks.$touch()"
            ></v-textarea>
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-col cols="12" md="12" sm="12" lg="12">
            <p>Invoice</p>
            <v-btn                      
              color="blue-grey"
              class="white--text"
              @click="$refs.mediaUpload.click()"                 
            >
              Upload
              <v-icon
                right
                dark
              >
                mdi-cloud-upload
              </v-icon>
            </v-btn>
            <input
              type="file"
              name="media"
              style="display: none"
              ref="mediaUpload"
              id="fileToUpload"
              accept=".pdf"
              @change="prepareUpload"
            />
          </v-col>
        </v-row>
        <v-row v-if="uploadFiles.length > 0" >
          <v-col cols="12" sm="12" md="3" lg="3" v-for="(item, index) in uploadFiles" :key="index" align="center">                   
            <a :href="item.url" target="_blank">
              <v-img
                  width="67" height="85"
                  src="../static/img/pdf.png"
                  aspect-ratio="1"
                ></v-img>
                <p class="pt-2 mb-0">{{item.name}}</p>
            </a>                        
            <v-btn dark icon @click="deleteFile(index)">
              <v-icon dark color="red">cancel</v-icon>
            </v-btn>
          </v-col>
        </v-row> -->
        <v-row v-if="activePairingData.history.length > 0">
          <v-col cols="12" md="12" sm="12" lg="12">
            <h4>Payout History</h4>
          </v-col>
          <v-col cols="12" md="12" sm="12" lg="12">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Date Time</th>
                    <th class="text-left">Old Amount</th>
                    <th class="text-left">New Amount</th>
                    <th class="text-left">Remark</th>
                    <th class="text-left">Invoice</th>
                    <th class="text-left">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, fileIndex) in activePairingData.history" :key="item.timestamp">
                    <td>{{ formatTime(item.timestamp) }}</td>
                    <td>${{ item.old_amount | thousandSeprator }}</td>
                    <td>${{ item.amount | thousandSeprator }}</td>
                    <td>{{ item.remarks }}</td>
                    <td>
                      <div v-if="item.invoices">
                        <v-btn text color="warning" :href="invoice.url" target="_blank" v-for="(invoice, index) in item.invoices" :key="index">
                          View PDF
                        </v-btn>
                      </div>
                    </td>
                    <td>
                      <v-btn 
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Delete Payout"
                      @click="deletePayout(fileIndex)"
                      color="error"
                      small>
                        <v-icon color="white" small>delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="$emit('input')">Close</v-btn>
        <v-btn color="green darken-1" text @click="processConfirmPayout()" :disabled="viewOnly">Save</v-btn>
      </v-card-actions>
    </v-card>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true"
      loader="bars"
      background-color="#000"
      color="secondary"
      width.number="90"
      height.number="90"
    ></loading>
    <!-- Influencer Detail Modal -->
    <influencer-detail-modal 
      :dialog="invoiceDialog" 
      :influencer="influencer" 
      @generatedInvoice="confirmPayout"
      :isGetInvoice="isGetInvoice"
      :close="closeModal"    />
    <!-- End of Influencer Detail Modal -->
  </v-dialog>
</template>
<script>
import utils from '../../../../utils'
import influencerDetailModal from './InfluencerDetailViewModal'
import campaignHelper from '../campaignHelper';
import api from '@/api';
import pairingAPIs from '../../Pairing/pairingAPIs';
import { required } from 'vuelidate/lib/validators'
import moment from 'moment'
import reverse from 'lodash/reverse';
import Loading from 'vue-loading-overlay';
// import config from '../config';
export default {
  components: { influencerDetailModal, Loading },
  data() {
    return {
      activePairingData: null,
      uploadFiles: [],
      deleteObjectKeys: [],
      isLoading: false,
      invoiceDialog: false,
      isGetInvoice: false
    };
  },
  props: {
    value: Boolean,
    data: Object,
    amount: Number,
    influencer: Object
  },
  watch: {
    value(value) {
      if (value) {
        this.activePairingData = Object.assign({}, this.data);
        this.clearForm()
        this.isGetInvoice = false
      }
    }
  },
  computed: {
  },
  validations: {
    activePairingData: {
      payout: {
        required
      },
      remarks: {
        required
      }
    }
  },
  methods: {
    async processConfirmPayout() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal({
          type: 'error',
          title: `Can't Submit with errors`,
          text: 'Make sure you filled the required information correctly.'
        });
        return;
      }
      const payload = Object.assign({}, {
        campaignID: this.activePairingData.CampaignID,
        handle: this.activePairingData.instagramHandle,
        platform: this.activePairingData.platform
      })
      await campaignHelper.invokeReportOwnerCheck(this, payload)
      // else if (this.uploadFiles.length === 0) {
      //   this.$swal({
      //     type: 'error',
      //     title: `Can't Submit with errors`,
      //     text: 'Please submit payout invoice.'
      //   });
      //   return;
      // }
      this.influencer = utils.func.refreshJSON(this.influencer)
      this.isGetInvoice = true
      this.invoiceDialog = true
    },
    confirmPayout(contractFile) {
      if (this.activePairingData !== null) {
        let formData = new FormData();
        formData.append('pairingID', this.activePairingData.pairingID);
        formData.append('amount', this.activePairingData.payout);
        formData.append('remarks', this.activePairingData.remarks);
        formData.append('uploadFile', contractFile);
        // if (this.uploadFiles.length > 0) {
        //   let files = this.uploadFiles;
        //   for (let val of files) {
        //     formData.append('uploadFile', val);
        //   }
        // }
        this.isLoading = true
        pairingAPIs
          .confirmAdminPayout(formData)
          .then((response) => {
            this.isGetInvoice = false
            this.isLoading = false
            this.activePairingData.payoutStatus = response.status
            this.activePairingData.history = response.history
            this.beautifyData()
            this.$swal({
              position: 'top-center',
              title: 'Payout Updated',
              type: 'success',
              showConfirmButton: false,
              timer: 1500
            });
            this.$emit('input');
            this.$emit('confirmedPayout', this.activePairingData);
          })
          .catch(error => {
            this.isLoading = false
            this.$swal({
              position: 'top-center',
              title: 'Error while updating payout',
              type: 'error',
              timer: 1500
            });
            console.log(error);
          });
      }
    },
    deletePayout(fileIndex) {
      this.$swal({
        title: 'Delete Confirm!',
        text: 'Are you sure you want to delete payout?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(result => {
        if (result.value) {
          let history = this.activePairingData.history[fileIndex]
          let updateHistory = Object.assign([], this.activePairingData.history)
          if (history.invoices !== undefined) {
            for (let invoice of history.invoices) {
              let filename = invoice.url.substring(invoice.url.lastIndexOf('/') + 1)
              this.deleteObjectKeys.push(filename)
            }
          }
          updateHistory.splice(fileIndex, 1)
          let formData = new FormData();
          formData.append('id', this.activePairingData.pairingID);
          formData.append('history', JSON.stringify(updateHistory));
          this.isLoading = true;
          pairingAPIs.updatePayoutHistory(formData)
            .then(response => {
              this.activePairingData.history = updateHistory
              this.activePairingData.payoutStatus = response.status
              this.isLoading = false;
              if (this.deleteObjectKeys.length > 0) {
                this.deleteObjectKeys.map(item => {
                  api.request('delete', '/api/v1/posts/s3/delete', true, {image: item})
                })
              }
              this.$emit('confirmedPayout', this.activePairingData);
              // Dismiss modal by triggering the click event on Close button
              this.$swal({
                text: 'Invoice Deleted',
                type: 'success'
              });
            })
            .catch(error => {
              // Request failed.
              console.log('error', error)
              this.isLoading = false;
            })
        }
      })
    },
    prepareUpload(e) {
      const uploadedFiles = Object.keys(e.target.files).map(i => e.target.files[i]);
      uploadedFiles.forEach(element => {
        let fileType = element.name.split('.')[1];
        if (fileType !== 'pdf') {
          this.$swal('File Type Not Supported, Please select a video or an image');
        } else {
          this.uploadFiles = [] // to allow one file currently...
          this.uploadFiles.push(element);
          const reader = new FileReader();
          reader.readAsArrayBuffer(element);
          e.target.value = '';
        }
      });
    },
    closeModal() {
      this.isGetInvoice = false
      this.invoiceDialog = false
    },
    deleteFile(fileIndex) {
      this.uploadFiles.splice(fileIndex, 1)
    },
    beautifyData() {
      if (this.activePairingData.history !== undefined) {
        this.activePairingData.history = reverse(this.activePairingData.history)
        console.log(this.activePairingData.history)
      }
    },
    clearForm() {
      this.activePairingData.remarks = ''
      this.uploadFiles = []
    },
    formatTime(value) {
      return moment(value).format('DD-MM-YYYY hh:mm:ss');
    }
  }
};
</script>



// WEBPACK FOOTER //
// PayoutConfirmModal.vue?30b64505